export default {
  INCREMENT: 'INCREMENT',
  DECREMENT: 'DECREMENT',
  TRANSFER_ALL: 'TRANSFER_ALL',
  RECLASSIFICATION: 'RECLASSIFICATION',
  ENTIRE_CLASS_RECLASSIFICATION: 'ENTIRE_CLASS_RECLASSIFICATION',
  MANUAL_RENUMERATION: 'MANUAL_RENUMERATION',
  ENTIRE_CLASS_RENUMERATION: 'ENTIRE_CLASS_RENUMERATION',
  AUTOMATIC_RENUMERATION: 'AUTOMATIC_RENUMERATION',
  SPLIT: 'SPLIT',
};
